module.exports = __webpack_public_path__ + "img/STHander_Sword Two-Hander Purple.cd7b98c4.png";